import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';
import { SpinnerCircular } from 'spinners-react';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex'
    },
    helpText: {
        marginLeft: theme.spacing[8],
        color: theme.colors.grey700
    }
}));

const LoadingSpinnerCircular = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { className } = props;
    return (
        <div className={classNames('test-loading-spinner', classes.container, className)}>
            <SpinnerCircular size={30} thickness={160} speed={100} color={theme.colors.primary500} secondaryColor={'transparent'} />
            <Typography className={classes.helpText}>Hold Tight, we're submitting your request...</Typography>
        </div>
    );
};

LoadingSpinnerCircular.propTypes = {
    className: PropTypes.string
};

export { LoadingSpinnerCircular };
